
export class Entidade {
    constructor() {
      this.Id = 0;
      this.TipoEntidade = new TipoEntidade;
      this.Cnpj = '';
      this.Codigo = 0;
      this.Descricao = '';
      this.Imagem = '';
      this.DataCriacao = '1900-01-01';
      this.Usuario = '';
      this.Endereco = new Endereco;
  }
  public Id: number;
  public TipoEntidade: TipoEntidade;
  public Cnpj: string;
  public Codigo: number;
  public Descricao: string;
  public Imagem: string;
  public DataCriacao: string;
  public Usuario: string;
  public Endereco: Endereco;
}

export class TipoEntidade {
  constructor() {
    this.Id = 0;
    this.Descricao = '';
}

public Id: number;
public Descricao: string;
}

export class Endereco {
  constructor() {
    this.Cep ='';
    this.Logradouro = '';
    this.Numero = '';
    this.Complemento = '';
    this.Bairro = '';
    this.Municipio = '';
    this.Estado = '';
}

public Cep: string;
public Logradouro: string;
public Numero: string;
public Complemento: string;
public Bairro: string;
public Municipio: string;
public Estado: string;
}



